export default __webpack_public_path__ + "static/0067-04f63a7122117ce872f2d5d1bf3dbce6.png";